/* eslint-disable @scandipwa/scandipwa-guidelines/file-structure */
// eslint-disable-next-line import/prefer-default-export
export const LANG_BLOCK_POPUP = 'LANG_BLOCK_POPUP';
export const COUNTRY_FLAG_FOLDER = 'country_flag/';
